module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    class: [_vm.block]
  }, [_c('ButtonBlock', {
    class: [_vm.block + '-close'],
    attrs: {
      "blockModifiers": ['sandOnBlue', 'noBorder', 'noPadding'],
      "icon": "24px_close"
    },
    nativeOn: {
      "click": function($event) {
        _vm.close($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-headerMessage']
  }, [_c('div', {
    class: [_vm.block + '-header']
  }, [_vm._v("Get started")]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-text']
  }, [_vm._v("Send us your details, and we’ll get back to you as soon as possible.")])]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-form']
  }, [_c('div', {
    class: [_vm.block + '-column']
  }, [_c('input-form-block', {
    attrs: {
      "text": _vm.data.name
    },
    on: {
      "textChanged": function($event) {
        _vm.data.name = $event
      }
    }
  }), _vm._v(" "), _c('input-form-block', {
    class: {
      'bm-invalid': _vm.emailInvalid
    },
    attrs: {
      "text": _vm.data.email
    },
    on: {
      "textChanged": function($event) {
        _vm.data.email = $event
      }
    }
  }), _vm._v(" "), _c('input-form-block', {
    attrs: {
      "text": _vm.data.phone
    },
    on: {
      "textChanged": function($event) {
        _vm.data.phone = $event
      }
    }
  }), _vm._v(" "), _c('input-form-block', {
    attrs: {
      "text": _vm.data.companyName
    },
    on: {
      "textChanged": function($event) {
        _vm.data.companyName = $event
      }
    }
  }), _vm._v(" "), _c('label', {
    class: [_vm.block + '-checkBoxLabel'],
    attrs: {
      "for": "confirmStoreData"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "mailOrderSelection",
      "id": "confirmStoreData",
      "value": "Allowing Spotin to store and process my personal data."
    },
    on: {
      "change": _vm.allowStoreData
    }
  }), _vm._v(" "), _c('span', {
    class: [_vm.block + '-checkBox']
  }, [_c('icon-gb', {
    attrs: {
      "name": "spotin-24px_checkmark",
      "size": "large"
    }
  })], 1), _vm._v(" "), _c('span', {
    class: [_vm.block + '-agreementText']
  }, [_vm._v("\n            I'm allowing Spotin to store and process my personal data.\n          ")])])], 1), _vm._v(" "), _c('div', {
    class: [_vm.block + '-column']
  }, [_c('textarea-block', {
    attrs: {
      "text": _vm.data.message
    },
    on: {
      "textChanged": function($event) {
        _vm.data.message = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-button']
  }, [_c('button-block', {
    attrs: {
      "blockModifiers": ['blueOnSand'],
      "text": _vm.data.buttonText
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendMessage($event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "successTransition"
    }
  }, [(_vm.success) ? _c('div', {
    class: [_vm.block + '-success']
  }, [_c('div', {
    class: [_vm.block + '-successText']
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.sentHtml)
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-okButton'],
    on: {
      "click": function($event) {
        _vm.success = false
      }
    }
  }, [_vm._v("OK")])])]) : _vm._e()])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-481044af","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/combinedBlocks/GetStarted.vue
// module id = 492
// module chunks = 0